<div class="container">
	<div class="login-body">
		<div id="header-logo">
			<div class="login-section">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
                <img *ngIf="pageDetails?.existsInstituteLogo" class="institute-logo" [src]="pageDetails?.instituteLogoPath" alt="Institute"/>

            </div>
		</div>
		<form class="passwordForm" class="js-reset-form login-form login-forgot-password" (keyup.enter)="doPostResetAction()">
			<h2 class="text-center" jhiTranslate="login.reset.header">Reset your password</h2>
			<p jhiTranslate="login.reset.message1">Now you can reset a new password for your account</p>
			<p jhiTranslate="login.reset.message2">Please fill in the form below.</p>

			<div class="login-form-control" [ngClass]="{ 'login-validation-error': this.errorFields.includes('password') }">
				<span class="login-icon fa login-icon" title="{{ 'login.password.title' | translate}}">&#xf084;</span>
				<input class="js-reset-password login-input login-flat-control" name="password" placeholder="{{ 'login.password.title' | translate}}" type="password" [(ngModel)]="model.password"
					   data-bs-toggle="tooltip" (keyup)="assessPasswordStrength($event)"/> <!--TODO pw reqt mesg - title-->
			</div>

			<div class="progress password-progress">
				<div id="strengthBar" role="progressbar" [ngClass]="'progress-bar '+ progressBarClass" [ngStyle]="{width: progressWidth}">
					<span id="strengthMessage">{{this.strengthMsg}}</span>
				</div>
			</div>

			<div class="login-form-control login-confirm-password-control"  [ngClass]="{ 'login-validation-error': this.errorFields.includes('passwordConfirmation') }" >
				<span class="login-icon fa login-icon" title="{{ 'login.confirm.password' | translate }}">&#xf084;</span>
				<input class="js-reset-forgot-password login-input login-flat-control" name="passwordConfirmation" placeholder="{{ 'login.confirm.password' | translate }}" type="password"
					   [(ngModel)]="model.passwordConfirmation" />
			</div>

			<div *ngIf="!this.isFormValid" class="js-login-error">
				<span class="fa login-warning-icon">&#xf12a;</span>
				<span class="js-login-error-text">{{this.errorMessage}}</span>
			</div>

			<button class="js-login-submit login-submit login-flat-control login-clickable" formnovalidate="" type="submit"
					(click)="doPostResetAction()" [disabled]="isLoading" [ngClass]="{ 'loading': isLoading }">
				<span *ngIf="isLoading" class="throbber throbber-btn"></span>
				<span class="login-submit-label" jhiTranslate="login.reset.button">Reset Password</span>
			</button>
		</form>

		<div id="message">
			<div ng-if="pageDetails != null && pageDetails.footerMessage != ''">
				<div [textContent]="pageDetails.footerMessage" class="login-footer-message">
				</div>
			</div>
		</div>

		<div id="footer">
			<div class="login-footer">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-footer-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
				<div class="login-footer-body">
					<span jhiTranslate="about.version.prefix"></span><span [innerText]="version"></span> &bull;
					{{'login.provider.message' | translate}} <a href="https://www.integratedbreeding.net/" jhiTranslate="login.provider.ibp">Integrated Breeding Platform</a>
				</div>
			</div>
			<jhi-languange-selector></jhi-languange-selector>
		</div>
	</div>
</div>
